<!--
  File name: Guest.vue
  Program Description:
    - Dashboard forguest users
    - Uses the Dashboard component
-->
<template>
  <Dashboard :show-drawer="false">
    <template v-slot:content>
      <router-view @alert="bubbleAlert($event)" />
    </template>
  </Dashboard>
</template>

<script>
import Dashboard from '@/components/Dashboard'

export default {
  name: 'Guest',
  components: {
    Dashboard
  }
}
</script>
